export const removeHttpProtocol = (url) => {
    var _a;
    return (_a = url === null || url === void 0 ? void 0 : url.replace(/^https?:\/\//, '')) === null || _a === void 0 ? void 0 : _a.replace(/\/$/, '');
};
//# sourceMappingURL=remove-http-protocol.js.map